import {
  IDENTITY_INFO_EDIT_MODAL_OPEN,
  IDENTITY_INFO_EDIT_MODAL_CLOSE,
  IDENTITY_INFO_EDIT_MODAL_SAVE_CHANGES,
  IDENTITY_INFO_EDIT_MODAL_VALIDATE,
  IDENTITY_INFO_EDIT_MODAL_CANCEL,
  IDENTITY_INFO_EDIT_MODAL_RESET,
} from '../actions/identity_info_modal_dialog'

export function identityInfoModalDialog(
  state = {
    isModalDialogOpen: false,
    newData: null,
    isChangesSaved: false,
    isValidated: true,
    content: null,
  },
  action
) {
  switch (action.type) {
    case IDENTITY_INFO_EDIT_MODAL_OPEN:
      return {
        ...state,
        isModalDialogOpen: true,
        content: action.content,
      }
    case IDENTITY_INFO_EDIT_MODAL_CLOSE:
      return {
        ...state,
        isModalDialogOpen: false,
        isChangesSaved: false,
        isValidated: true,
      }
    case IDENTITY_INFO_EDIT_MODAL_CANCEL:
      return {
        ...state,
        isModalDialogOpen: false,
        isChangesSaved: false,
        isValidated: true,
        newData: null,
      }
    case IDENTITY_INFO_EDIT_MODAL_SAVE_CHANGES:
      return {
        ...state,
        isChangesSaved: true,
        newData: action.newData,
      }
    case IDENTITY_INFO_EDIT_MODAL_VALIDATE:
      return {
        ...state,
        isValidated: action.isValidated,
      }
    case IDENTITY_INFO_EDIT_MODAL_RESET:
      return {
        ...state,
        newData: null,
        isChangesSaved: false,
      }
    default:
      return state
  }
}
